import { RootState } from 'src/logic/features/root-state.model';

export const isCareerHubVersion = (state: RootState, major: number, minor: number): boolean => {
    if (state.configuration.value.disableVersionChecks) {
        return true;
    }

    const version = state.apiConfiguration.version;

    if (version.major > major) {
        return true;
    }

    return version.major === major && version.minor >= minor;
};
